export default "__VITE_ASSET__0df860b2__"